import { Pipe, PipeTransform } from '@angular/core';
import { UserMailAccountSearchOrder } from '@app-types/enums/UserMailAccountSearchOrder';

@Pipe({
  name: 'formatUsersMailAccountSearchOrders',
  standalone: true,
})
export class FormatUsersMailAccountSearchOrders implements PipeTransform {
  transform(order: string): UserMailAccountSearchOrder {
    switch (order) {
      case 'firstName':
        return UserMailAccountSearchOrder.OrderByFirstName;
      case 'lastName':
        return UserMailAccountSearchOrder.OrderByLastName;
      case 'GAW':
        return UserMailAccountSearchOrder.OrderByOidcIdentity;
      case 'adfs':
        return UserMailAccountSearchOrder.OrderByAdfsIdentity;
      case 'email':
        return UserMailAccountSearchOrder.OrderByEmail;
      case 'role':
        return UserMailAccountSearchOrder.OrderByRole;
      default:
        return UserMailAccountSearchOrder.OrderByUserMailAccountId;
    }
  }
}
